import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core'
import StyledIconWrapper from './Styled/StyledIconWrapper'
import { ReferenceDataIcon } from 'dls/atoms/Icons/SVGIcons'

const AdministratorsMenuItem = ({ isActive }: { isActive: boolean }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const inActiveColor = theme.palette.text.secondary
  return (
    <div>
      <StyledIconWrapper>
        <ReferenceDataIcon
          aria-hidden="true"
          style={{ verticalAlign: 'bottom', color: !isActive ? inActiveColor : 'inherit' }}
        />
      </StyledIconWrapper>
      {t('Administrator')}
    </div>
  )
}

export default AdministratorsMenuItem
